/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Player_Not_FoundInputs */



/**
* | output |
* | --- |
* | "Player not found" |
*
* @param {Err_Tournament_Player_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_player_not_found = /** @type {((inputs?: Err_Tournament_Player_Not_FoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Player_Not_FoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Joueur introuvable")
	if (locale === "es") return /** @type {LocalizedString} */ ("Jugador no encontrado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogador não encontrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giocatore non trovato")
	return /** @type {LocalizedString} */ ("Player not found")
});